import {
    updateSharingLinkFromSharingDialog,
    updateSharePointLinkUrl,
} from '../actions/internalActions';
import getSharingLink from '../selectors/getSharingLink';
import SharingLinkInfo from '../store/schema/SharingLinkInfo';
import { mutator } from 'satcheljs';
import { userDate } from 'owa-datetime';

mutator(updateSharingLinkFromSharingDialog, actionMessage => {
    const sharingLink: SharingLinkInfo = getSharingLink(actionMessage.linkId);
    if (!!sharingLink) {
        sharingLink.sharingInfo.expirationDate = actionMessage.sharingDialogResponse.expirationDate;
    }
});

mutator(updateSharePointLinkUrl, actionMessage => {
    const sharingLink: SharingLinkInfo = getSharingLink(actionMessage.linkId);
    if (!!sharingLink) {
        sharingLink.sharingInfo.expirationDate = actionMessage.expirationDate
            ? userDate(actionMessage.expirationDate)
            : null;
    }
});
